import type { PropsWithChildren } from 'react';
import React from 'react';

import { css } from '@emotion/react';
import { colors, HStack, useTheme } from '@rtkwlf/fenrir-react';

type NavigationHeaderProps = PropsWithChildren;

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  children,
}) => {
  const theme = useTheme();
  const isDarkMode = theme?.themeMode === 'dark';

  // UX team had a decision to use the light theme brandSecondary color as nav item's hover background for both dark and light modes.
  // The change below is to make nav bar colors look the same for both theme modes
  // but still use Fenrir's colors rather than hardcoding HEX colors.
  const skeletonBackground = isDarkMode
    ? colors.background.brand.tertiary
    : colors.background.brand.secondary;

  const skeletonBackgroundOpacity = isDarkMode ? '0.25' : '1';

  return (
    <HStack
      gap="small"
      css={css({
        '&:hover': {
          backgroundColor: `rgba(${skeletonBackground}, ${skeletonBackgroundOpacity})`,
        },
      })}
      borderRadius="default"
      fontFamily="body"
      padding="small"
      fontSize={{
        laptop: 'small',
        monitor: 'default',
      }}
      textColor="monoWhite"
    >
      {children}
    </HStack>
  );
};
